export default "__VITE_ASSET__BLpLZX1k__"